import { createTheme, Palette, TypeBackground } from '@mui/material';

const defaultTheme = createTheme();

interface CustomBackground extends TypeBackground {
  dark: string;
}

interface CustomBorders {
  default: string;
  dark: string;
  darkHover: string;
}

interface CustomPalette extends Palette {
  tertiary: Palette['primary'];
  background: CustomBackground;
  border: CustomBorders;
}

export const muiPalette: CustomPalette = {
  ...defaultTheme.palette,
  primary: {
    main: '#8AB2C4', // PMS 2205 C
    contrastText: '#FFFFFF',
    // light: '#F3F7F9', // -90% lighter
    // dark: '#455962', // +50% darker
    light: '#E2EBEF',
    dark: '#5B8699',
  },
  secondary: {
    main: '#A15A95', // PMS 7655 C
    contrastText: '#FFFFFF',
    light: '#F6EEF4', // -90%
    dark: '#502D4A', // +50%
  },
  tertiary: {
    main: '#C9704E',
    contrastText: '#FFFFFF',
    light: '#FBEDE7',
    dark: '#643827',
  },
  /*  grey: {
   ...defaultTheme.palette.grey,
   50: '#E5E4E2',
   100: '#D6D7D8', // K 18 - borders + divider
   200: '#C3C5C7', // K 27
   300: '#87898C', // K 56
   400: '#838487',
   600: '#374151',
   900: '#8ab2c40a',
   },*/
  grey: {
    ...defaultTheme.palette.grey,
    50: '#F8FAFC',
    100: '#F1F5F9',
    200: '#E2E8F0',
    300: '#CBD5E1',
    400: '#94A3B8',
    500: '#64748B',
    600: '#475569',
    700: '#334155',
    800: '#1E293B',
    900: '#0F172A',
  },
  background: {
    default: '#F8FAFC',
    paper: '#FFFFFF',
    dark: '#111827',
  },
  text: {
    primary: '#1E293B',
    secondary: '#64748B',
    disabled: '#94A3B8',
  },
  action: {
    ...defaultTheme.palette.action,
    disabledBackground: '#F5F5F5',
    hover: '#F3F7F980', // primary light opacity 50%
  },
  success: {
    ...defaultTheme.palette.success,
    main: '#10B981',
  },
  divider: '#E2E8F0',
  border: {
    default: '#D6D7D8',
    dark: '#FFFFFF0D', // white 5%
    darkHover: '#8ab2c40a',
  },
};